// theming/orderThemesForCards.js
/**
 * Stable order for the card grid/gallery: seller default first, then the rest
 * newest-first. Deliberately does NOT promote the currently selected theme —
 * selection-driven reordering felt janky in practice.
 */
export function orderThemesForCards(themes, { defaultThemeId } = {}) {
  const list = Array.isArray(themes) ? themes : [];
  const defaultTheme = list.find(theme => theme._id === defaultThemeId);
  const rest = list
    .filter(theme => theme._id !== (defaultTheme && defaultTheme._id))
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
  return defaultTheme ? [defaultTheme, ...rest] : rest;
}

export default orderThemesForCards;
